import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useState} from "react";
import {authActions} from "../_services/essentials/store";
import {history} from "../_services/essentials/helpers";
import {useLocation} from "react-router-dom";

interface ContinueSessionProps {
    open: boolean;
}

export { ContinueSession };

function ContinueSession({ open }: ContinueSessionProps) {

    const auth = useSelector(x => x.auth.value);
    const token_expiry_time_in_ms = useSelector(x => x.auth.token_expiry_time_in_ms);
    const dispatch = useDispatch();
    history.location = useLocation();

    const [ continueSessionPage, setContinueSessionPage ] = useState(false);
    const [ tokenExpiryTimeInMs, setTokenExpiryTimeInMs ] = useState(-1);
    const [ pauseSessionCheck, setPauseSessionCheck ] = useState(false);
    const [ elaspsedTime, setElaspsedTime ] = useState(-1);
    const [ userIdleState, setUserIdleState ] = useState(false);

    const currentPath = history.location.pathname;

    const whitelist = [
        '/'
    ];
    const inactiveTimeoutInMs = 1000 * 60 * 15; // 15 Minutes
    const warningMessageTimeoutInSeconds = 60; // 60 seconds
    const warningMessagerefreshIntervalInMs = 1000; // 1 second
    const warningMessagerefreshIntervalInSeconds = warningMessagerefreshIntervalInMs/1000;   // 1 second
    const pauseSessionCheckDelayInMs = 2 * 1000; // 2 seconds

    const warningMessagePreparationTimeoutInSeconds = 120;
    const warningMessagePreparationIntervalInMs = 60000; // 60 seconds //1 Minute
    const warningMessagePreparationIntervalInSeconds = warningMessagePreparationIntervalInMs/1000;  // 60 seconds //1 Minute

    let timeout: NodeJS.Timeout | null = null;

    const restartAutoReset = () => {
        if (timeout) {
            clearTimeout(timeout);
        }
        timeout = setTimeout(() => {
            setUserIdleState(true);
        }, inactiveTimeoutInMs);
    };

    const onMouseMove = () => {
        restartAutoReset();
    };

    useEffect(() => {
        setTokenExpiryTimeInMs(token_expiry_time_in_ms);
    }, [token_expiry_time_in_ms]);

    useEffect(() => {
        const currentTimeInMs = new Date().getTime();
        if(tokenExpiryTimeInMs && tokenExpiryTimeInMs !==-1 && currentTimeInMs) {
            setElaspsedTime(Math.round((tokenExpiryTimeInMs - currentTimeInMs)/1000)-60);
        }
    }, [tokenExpiryTimeInMs]);

    useEffect(() => {
        if(!pauseSessionCheck && auth&& elaspsedTime!==-1) {
            doAuthCheck(elaspsedTime);
        }
    }, [elaspsedTime]);

    useEffect(() => {
        // Whitelist certain pages
        let preventReset = false;
        for (const path of whitelist) {
            if (path === currentPath) {
                preventReset = true;
            }
        }
        if (preventReset) {
            return;
        }

        // initiate timeout
        restartAutoReset();

        // listen for mouse events
        window.addEventListener('mousemove', onMouseMove);

        // cleanup
        return () => {
            if (timeout) {
                clearTimeout(timeout);
                window.removeEventListener('mousemove', onMouseMove);
            }
        };
    }, [currentPath]);

    async function doAuthCheck(elaspsedTime) {

        const authToken = await dispatch(authActions.getAuth()).unwrap();

        if(authToken) {
            if (elaspsedTime && elaspsedTime!==-1) {
                if (elaspsedTime <= warningMessageTimeoutInSeconds && elaspsedTime > 0) {
                    setTimeout(function () {
                        setElaspsedTime(elaspsedTime - warningMessagerefreshIntervalInSeconds);
                    }, warningMessagerefreshIntervalInMs);
                    if(userIdleState) {
                        setContinueSessionPage(true);
                    } else {
                        continueSession();
                    }
                } else if (elaspsedTime >= warningMessagePreparationTimeoutInSeconds) {
                    setContinueSessionPage(false);
                    setTimeout(function () {
                        setElaspsedTime(elaspsedTime - warningMessagePreparationIntervalInSeconds);
                    }, warningMessagePreparationIntervalInMs);
                } else if (elaspsedTime > warningMessageTimeoutInSeconds && elaspsedTime < warningMessagePreparationTimeoutInSeconds) {
                    setContinueSessionPage(false);
                    setTimeout(function () {
                        setElaspsedTime(elaspsedTime - warningMessagerefreshIntervalInSeconds);
                    }, warningMessagerefreshIntervalInMs);
                } else {
                    signoutSession();
                }
            } else if (elaspsedTime===0){
                signoutSession();
            }
        }
    }

    async function continueSession(){
        setContinueSessionPage (false);
        setPauseSessionCheck(true);
        setTimeout(async function(){
            setPauseSessionCheck(false);
            await dispatch(authActions.extendToken());
            const newTokenExpiryTimeInMs = await dispatch(authActions.getTokenExpiryTimeInMs()).unwrap();
            setTokenExpiryTimeInMs(newTokenExpiryTimeInMs);
        }, pauseSessionCheckDelayInMs);
    }

    function signoutSession(){
        setContinueSessionPage (false);
        dispatch(authActions.logout());
    }


    return (
        <Dialog
            open={continueSessionPage}
            onClose={()=>{console.log('')}}
            PaperProps={{
                component: 'form',
                onSubmit: (event: React.FormEvent<HTMLFormElement>) => {
                    event.preventDefault();
                    continueSession();
                },
            }}
        >
            <DialogTitle>Session Warning</DialogTitle>
            <DialogContent
                sx={{ display: 'flex', flexDirection: 'column', gap: 2, width: '100%' }}
            >
                <DialogContentText>
                    Your user session will expire in {elaspsedTime} seconds. If your session expires, all of your unsaved data will be lost. Would you like to continue the session?
                </DialogContentText>
            </DialogContent>
            <DialogActions sx={{ pb: 3, px: 3 }}>
                <Button variant="contained" type="submit">Continue</Button>
                <Button onClick={()=>signoutSession()}>Sign out</Button>
            </DialogActions>
        </Dialog>
    );
}
